import Spinner from '@shared/components/Spinner';
import styles from './Loader.module.css';

const Loader = () => {
  return (
    <div className={styles.container}>
      <Spinner />
    </div>
  );
};

export default Loader;
